import { WithSurveyNamespace } from '../../state/survey';
import { getNamespaceValue } from '../utils/selector';

export const getQuestionsCollection = (state: WithSurveyNamespace) =>
    getNamespaceValue(state.survey, 'questionsCollection');

export const getInteractiveQuestionsByAttendeeId = (
    state: WithSurveyNamespace,
) => getNamespaceValue(state.survey, 'interactiveQuestionsByAttendeeId', {});
